const generalFR = {
    "modalConfirm": {
        "button": {
            "cancel": "Annuler",
            "confirm": "Confirmer"
        }
    },
    "tableDropdown": {
        "action": "Action",
        "edit": "Modifier",
        "delete": "Supprimer",
        "viewDetails": "Voir les détails",
        "copyMLId": "Copier l'ID ML",
        "viewStats": "Voir les statistiques"
    },
    "tableModal": {
        "cancel": "Annuler",
        "confirm": "Confirmer",
        "edit": "Modifier"
    },
    "invoiceModal": {
        "button": {
            "cancel": "Annuler",
            "confirm": "Confirmer"
        }
    },
    "select": {
        "placeholder": "Sélectionner..."
    },
    "asyncDropdown": {
        "placeholder": "Rechercher...",
        "loading": "Chargement...",
        "noResults": "Aucune option",
        "blacklisted": "Liste noire"
    },
    "table": {
        "noDataAvailable": "Aucune donnée disponible"
    },
    "tableHelper": {
        "loading": "Chargement...",
        "error": "Une erreur s'est produite",
        "noData": "Il n'y a pas de données disponibles"
    },
    "countriesSelect": {
        "placeholder": "Rechercher un pays..."
    },
    "consentModal": {
        "header": "Consentement requis",
        "body": {
            "description": "Veuillez examiner et accepter nos nouveaux termes de consentement pour continuer à utiliser nos services.",
            "label": {
                "firstName": "Prénom",
                "lastName": "Nom de famille",
                "email": "Email",
                "termsOfUsageAgreement": "J'accepte les <1>Conditions d'utilisation</1>",
                "privacyPolicyAgreement": "J'accepte la <1>Politique de confidentialité</1>",
                "cookiePolicyAgreement": "J'accepte la <1>Politique de cookies</1>"
            }
        },
        "button": {
            "submit": "Soumettre"
        }
    },
    "passwordResetModal": {
        "header": "Changez votre mot de passe",
        "body": {
            "form": {
                "label": {
                    "currentPassword": "Mot de passe actuel",
                    "newPassword": "Nouveau mot de passe",
                    "repeatNewPassword": "Répétez le nouveau mot de passe"
                },
                "button": {
                    "submit": "Soumettre"
                },
                "message": {
                    "currentPasswordRequired": "Votre ancien mot de passe est requis",
                    "newPasswordRequired": "Nouveau mot de passe requis",
                    "newPasswordMinLength": "Votre mot de passe doit comporter au moins 10 caractères",
                    "newPasswordDifferentFromOld": "Le nouveau mot de passe doit être différent de l'ancien mot de passe",
                    "newPasswordConfirmation": "Le nouveau mot de passe doit correspondre"
                }
            }
        },
        "footer": {
            "note": "<strong>Remarque : </strong>Il y a un moment que vous n'avez pas mis à jour votre mot de passe. Pour votre sécurité, veuillez réinitialiser votre mot de passe."
        },
        "message": {
            "success": "Votre mot de passe a été changé !",
            "error": "Quelque chose s'est mal passé ! Veuillez actualiser la page et réessayer !"
        },
        "modal": {
            "confirm": {
                "header": "Êtes-vous sûr de vouloir changer votre mot de passe ?",
                "body": "Veuillez confirmer"
            }
        }
    },
    "qcFeedback": {
        "label": {
            "qcFeedback": "Retour QC"
        }
    },
    "subUserFilter": {
        "label": {
            "subUser": "Sous-utilisateur : "
        },
        "placeholder": {
            "subUser": "Sélectionner un sous-utilisateur"
        },
        "button": {
            "reset": "Réinitialiser"
        }
    },
    "footer": {
        "label": {
            "copyright": "Droits d'auteur © {{year}}",
            "allRightsReserved": "Tous droits réservés.",
            "privacyPolicy": "Politique de confidentialité",
            "termsAndConditions": "Termes et conditions"
        }
    },
    "promoBannerHeader": {
        "exclusiveOfferFor": "Offre Exclusive pour",
        "off": "OFF",
        "promoCode": "Code Promo",
        "expiresIn": "Expire en",
        "clickHereToAvailThisOffer": "Cliquez ici pour profiter de cette offre",
        "availableOnAllSubscriptionPlans": "Disponible sur tous les plans de souscription."
    },
    "promoBanner": {
        "exclusiveOfferFor": "Offre Exclusive pour",
        "off": "OFF",
        "limitedTimePromoOffer": "Ce Code Promo Limité a été créé exclusivement pour vous. Ne ratez pas cette opportunité!",
        "promoCode": "Votre Code Promo",
        "expiresIn": "Expire en",
        "days": "Jours",
        "hours": "Heures",
        "minutes": "Minutes",
        "seconds": "Secondes",
        "availableOnAllSubscriptionPlans": "Cette offre exclusive est disponible sur tous les plans de souscription."
    }
};

export default generalFR;